import React from 'react'

const Car = () => {
    return (
        <div>
            car
        </div>
    )
}

export default Car
